import {ConfigService, ErrorsService, FieldCrop, ModelsList, StoreService} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class FieldCropService extends StoreService<FieldCrop> {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(FieldCrop);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<FieldCrop>> {
    return this.http.get<ModelsList<FieldCrop>>(this.config.apiVerUrl('/app/field-crops'), {params: queryParams});
  }

  insert(values: FieldCrop): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/field-crops'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/field-crops/${id}`));
  }

  update(id, values: FieldCrop): Observable<FieldCrop> {
    return this.http.put<FieldCrop>(this.config.apiVerUrl(`/app/field-crops/${id}`), values);
  }

}
